<template>
  <div class="poiSearchInput" v-show="!spaceSearchJeojson && !isShowSpaceTool && !isDrawState && !shared">
    <el-input placeholder="请根据名称查找" :disabled="isDrawState" v-model="searchInputText" class="input-with-select" clearable @input="onSearchInput" @keyup.enter.native="onSearchMarker" @clear="onClearSearch">
      <el-select class="type-select" slot="prefix" v-model="searchType" placeholder="请选择" @change="onChangeType">
        <el-option class="search-type-option" label="POI" value="1" :disabled="isTemplate"></el-option>
        <el-option class="search-type-option" label="标注" value="2" :disabled="!isMarkerView"></el-option>
      </el-select>
      <i class="el-icon-search" slot="suffix" @click="onSearchMarker"></i>
    </el-input>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'PoiSearchInput',
  data () {
    return {
      searchType: '1',
      searchInputText: '',
      isMarkerView: true
    }
  },
  inject: ['shared'],
  computed: {
    ...mapGetters(['isTemplate', 'isDrawState', 'spaceSearchJeojson', 'isShowSpaceTool'])
  },
  mounted () {
    this.isMarkerView = this.$route.name === 'Marker'
    if (this.isTemplate) {
      this.searchType = '2'
    }
    if (this.shared) {
      this.searchType = '2'
    }
  },
  watch: {
    $route (to, from) {
      this.isMarkerView = to.name === 'Marker'
    }
  },
  methods: {
    search () {
      const params = {}
      params.searchType = this.searchType
      params.searchInputText = this.searchInputText
      params.curPage = 1
      this.$store.commit('SET_SEARCH_PARAMS', params)
    },
    onSearchInput (key, args) {
      this.search()
    },
    onClearSearch () {
      this.search()
    },
    onChangeType () {
      this.searchInputText = ''
      this.search()
    },
    onSearchMarker () {

    }
  }
}
</script>

<style lang="scss">
.poiSearchInput{
  width: 260px;
  .type-select{
    width: 52px;
    &.el-select{
      .el-input__inner{
        border: unset;
        padding: 0;
        padding-left: 8px;
        font-size: 12px !important;
        border-radius: 0;
        background: unset;
      }
      .el-input__icon{
        width: 12px;
      }
    }
  }
  .el-input__suffix {
    .el-icon-search {
      &:hover {
        color: unset !important;
      }
    }
  }
  .el-input--prefix{
    .el-input__inner{
      padding-left: 60px;
      padding-right: 60px;
    }
  }
  .el-input__prefix{
    left: 0px;
    .el-input__suffix-inner{
      height: 40px;
      transform: translateX(2px);
    }
  }
  .el-input-group{
    width: 260px;
    height: 32px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid #000000;
    border-radius: 6px;
    .el-input-group__prepend{
      width: 52px;
      background-color: unset;
      color: unset;
      border: unset;
      border-radius: unset;
      .el-input__inner{
        font-size: 12px !important;
        padding: 0 6px !important;
      }
      .el-input__icon{
        width: 15px !important;
      }
    }
  }
  .el-icon-search{
    // cursor: pointer;
    width: 32px;
    height: 32px;
    background: rgba($color: #FFFFFF, $alpha: 0.1);
    // opacity: 0.1;
    border-radius: 0px 6px 6px 0px;
    line-height: 32px;
    margin-right: -5px;
  }
  .el-input__clear{
    position:absolute;
    right: 32px;
    top: -5px;
  }
  .el-input {
    .el-input__inner{
      &:focus {
        box-shadow: unset;
      }
    }
  }
}
.search-type-option{
  &.el-select-dropdown__item{
    font-size: 12px !important;
    padding: 0 10px !important;
    text-align: center;
  }
}
</style>
